import React, { Component } from 'react'

class Module3 extends Component{
    constructor(props){
        super(props)
        
    }
    render(){
        return(
            <section className="section-wrap page3">
                <div className="block column3">
                    <div className="block-head">
                        <h2 className="block-title">{ this.props.title }</h2>
                    </div>
                    <div className="block-body">
                        <img width="1200" src={ this.props.src }/>
                    </div>
                </div>
            </section>
        )
    }
}

export default Module3;
